module.exports = __webpack_public_path__ + "static/media/New Project.cdb6e122.png";